import { render, staticRenderFns } from "./WaitinglistPartner.vue?vue&type=template&id=14c25594&"
import script from "./WaitinglistPartner.vue?vue&type=script&lang=js&"
export * from "./WaitinglistPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports